<div class="grid-container">
  <div class="grid-row grid-gap-1">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
      <legend class="usa-legend usa-legend--large">{{ title }}</legend>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-bottom-205">
      <b>Select one or more HHG and/or SIT Quarterly Reports to pay and then select "Pay Selected AFs"</b>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-bottom-205">
      <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      @if (gridOptions) {
        <ag-grid-angular style="height: 600px;" class="ag-theme-alpine" [components]="frameworkComponents" [gridOptions]="gridOptions"
          [rowData]="IFFShipmentPaginationResults$ | async"
          [enableCharts]="true"
          [enableRangeSelection]="true">
        </ag-grid-angular>
      }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 pt-4" *ngIf="!disableSelect">
      <button type="button" class="usa-button usa-button--primary" (click)="payIffs()" [disabled]="isNoRowSelected$ | async">
        Pay Selected AFs
      </button>
    </div>
  </div>
</div>
